import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";

export const clonePossession = (possession, previousEndDate, createReference = uuidv4) => {
  const clonedPossession = cloneDeep(possession || {});
  const references = {};

  (clonedPossession.worksites || []).forEach((worksite) => {
    (worksite?.lines_at_site || []).forEach((line) => {
      const reference = createReference();
      if (line.line_reference) references[line.line_reference] = reference;
      line.line_reference = reference;
    });
  });

  (clonedPossession.level_crossings || []).forEach((crossing) => {
    if (!Array.isArray(crossing?.lines)) return;
    crossing.lines = crossing.lines
      .filter((line) => references[line?.line_reference])
      .map((line) => ({ ...line, line_reference: references[line.line_reference] }));
  });

  delete clonedPossession.planned_start_date;
  delete clonedPossession.planned_end_date;
  if (previousEndDate) clonedPossession.planned_start_date = previousEndDate;

  return clonedPossession;
};
